export default {
  disableDataAggregation: {
    VIDEO_NOTE_PROPERTIES: 'VIDEO_NOTE_PROPERTIES',
    NOTE_TEXT: 'NOTE_TEXT',
  },
  disableTopHighlightsDisplay: {
    POPULAR_HIGHLIGHTS: 'POPULAR_HIGHLIGHTS',
  },
};
